import { render, staticRenderFns } from "./infracciones.vue?vue&type=template&id=0d499266&scoped=true&"
import script from "./infracciones.vue?vue&type=script&lang=js&"
export * from "./infracciones.vue?vue&type=script&lang=js&"
import style0 from "./infracciones.vue?vue&type=style&index=0&id=0d499266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d499266",
  null
  
)

export default component.exports